import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const FileVideo = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M6.25 7.50003C6.94036 7.50003 7.5 6.94039 7.5 6.25003C7.5 5.55967 6.94036 5.00003 6.25 5.00003C5.55964 5.00003 5 5.55967 5 6.25003C5 6.94039 5.55964 7.50003 6.25 7.50003Z'
          fill='currentColor'
        />
        <path
          d='M13 12.9408V17.0598C13 17.6666 13.683 18.0222 14.1801 17.6742L17.1223 15.6147C17.5488 15.3161 17.5488 14.6844 17.1223 14.3859L14.1801 12.3264C13.683 11.9784 13 12.334 13 12.9408Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2 4.75003C2 3.23125 3.23122 2.00003 4.75 2.00003H13.25C14.7688 2.00003 16 3.23125 16 4.75003V8.00003H19.25C20.7688 8.00003 22 9.23125 22 10.75V19.25C22 20.7688 20.7688 22 19.25 22H10.75C9.23122 22 8 20.7688 8 19.25V16H4.75C3.23122 16 2 14.7688 2 13.25V4.75003ZM14.5 4.75003V8.00003H10.75C9.33462 8.00003 8.16899 9.0693 8.01682 10.4441L7.52348 10.1152C6.59976 9.4994 5.39635 9.4994 4.47263 10.1152L3.5 10.7636V4.75003C3.5 4.05967 4.05964 3.50003 4.75 3.50003H13.25C13.9404 3.50003 14.5 4.05967 14.5 4.75003ZM6.69143 11.3633L8 12.2357V14.5H4.75C4.05964 14.5 3.5 13.9404 3.5 13.25V12.5664L5.30468 11.3633C5.72456 11.0834 6.27156 11.0834 6.69143 11.3633ZM9.5 19.25V10.75C9.5 10.0597 10.0596 9.50003 10.75 9.50003H19.25C19.9404 9.50003 20.5 10.0597 20.5 10.75V19.25C20.5 19.9404 19.9404 20.5 19.25 20.5H10.75C10.0596 20.5 9.5 19.9404 9.5 19.25Z'
          fill='currentColor'
        />
      </>
    ) : (
      <>
        <path
          d='M6.25 7.50003C6.94036 7.50003 7.5 6.94039 7.5 6.25003C7.5 5.55967 6.94036 5.00003 6.25 5.00003C5.55964 5.00003 5 5.55967 5 6.25003C5 6.94039 5.55964 7.50003 6.25 7.50003Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.75 2.00003C3.23122 2.00003 2 3.23125 2 4.75003V13.25C2 14.7688 3.23122 16 4.75 16H8V19.25C8 20.7688 9.23122 22 10.75 22H19.25C20.7688 22 22 20.7688 22 19.25V10.75C22 9.23125 20.7688 8.00003 19.25 8.00003H16V4.75003C16 3.23125 14.7688 2.00003 13.25 2.00003H4.75ZM14.5 8.00003V4.75003C14.5 4.05967 13.9404 3.50003 13.25 3.50003H4.75C4.05964 3.50003 3.5 4.05967 3.5 4.75003V10.7636L4.47263 10.1152C5.39635 9.4994 6.59976 9.4994 7.52348 10.1152L8.01682 10.4441C8.16899 9.0693 9.33462 8.00003 10.75 8.00003H14.5ZM8 12.2357L6.69143 11.3633C6.27156 11.0834 5.72456 11.0834 5.30468 11.3633L3.5 12.5664V13.25C3.5 13.9404 4.05964 14.5 4.75 14.5H8V12.2357ZM13 17.0595V12.9405C13 12.3338 13.683 11.9781 14.1801 12.3261L17.1223 14.3856C17.5488 14.6842 17.5488 15.3159 17.1223 15.6145L14.1801 17.674C13.683 18.0219 13 17.6663 13 17.0595Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
